import React, { Fragment } from 'react';

const AccordionsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Accordion enables users to expand and collapse sections of content.
          </h1>
        </div>
        <div className="right">
          <p>Accordions are best used when the users need to consume specific areas of content within a page or when the vertical space available is limited. Use this component only when there is enough content to condense and avoid nested accordions because it increases the cognitive load for users.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Primary</h2>
          <p>The primary type is used in simple cases, where a simple title or an informative context must be shown on the page.</p>
          <h2 className="h2 page-subtitle">Secondary</h2>
          <p>The secondary type of accordion is used to show more details about a context on the page. This case usually is used on the details page where a lot of information must be shown.</p>
          <h2 className="h2 page-subtitle">Reduced Spaces including Mobile</h2>
          <p>The &#34;Reduced Spaces&#34; version, as predicted by the name, must be used to pages with reduced space or when in mobile devices.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default AccordionsUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Accordion/AccordionsUsage.js